export enum Post {
  SignIn = 'signin',
  DeleteAccount = 'deleteAccount',
  CreateCompanyLocations = 'createCompanyLocations',
  AddMatchTags = 'addMatchTags',
  RequestPasswordReset = 'requestPasswordReset',
  SecureObjectUpload = 'secureObjectUpload',
  SecureObjectDelete = 'secureObjectDelete',
  CreateApplicantSkills = 'createApplicantSkills',
  CreateCultureSurvey = 'createCultureSurvey',
  CreateCompanyDepartments = 'createCompanyDepartments',
  CreateCompanySubdepartments = 'createCompanySubdepartments',
  CreateCompanyBenefits = 'createCompanyBenefits',
  VerifyUser = 'verifyUser',
  ResendVerificationEmail = 'resendVerificationEmail',
  CreateCompanyAdmin = 'createCompanyAdmin',
  CreateMatchComment = 'createMatchComment',
  CreateExternalApplicant = 'createExternalApplicant',
  ValidateScreeningApplicantBatchInvitations = 'validateScreeningApplicantBatchInvitations',
  ConfirmScreeningApplicantBatchInvitations = 'confirmScreeningApplicantBatchInvitations',
  ResendExternalApplicantInvitation = 'resendExternalApplicantInvitation',
  SendCompleteSurveyToApplicant = 'sendCompleteSurveyToApplicant',
  GenerateCampaignToken = 'generateCampaignToken',
  CreateTalentSurvey = 'createTalentSurvey',
  GenerateNewQuestionnaire = 'generateNewQuestionnaire',
  CreateCompanySurvey = 'CreateCompanySurvey',
  UploadDocuments = 'uploadDocuments',
  SubmitLightCompanySurveyResults = 'submitLightCompanySurveyResults',
  CreateTalentPoolMatch = 'createTalentPoolMatch',
  AssignDepartmentTargetProfile = 'assignDepartmentTargetProfile',
  AddDepartmentTargetProfileSkill = 'addDepartmentTargetProfileSkill',
  CreateCompanyWorkforceProfile = 'createCompanyWorkforceProfile',
  ReanalyseCompanyWorkforceProfile = 'reanalyseCompanyWorkforceProfile',
  ResearchWorkforceProfileDraft = 'researchWorkforceProfileDraft',
  CreateOtp = 'createOtp',
  ValidateOtp = 'validateOtp',
}
